import { render } from "./selfBuildAppMenu.vue?vue&type=template&id=6084299c&scoped=true"
import script from "./selfBuildAppMenu.vue?vue&type=script&lang=js"
export * from "./selfBuildAppMenu.vue?vue&type=script&lang=js"

import "./selfBuildAppMenu.vue?vue&type=style&index=0&id=6084299c&lang=scss&scoped=true"
import "./selfBuildAppMenu.vue?vue&type=style&index=1&id=6084299c&lang=css"

import exportComponent from "D:\\客云\\newQsProject\\qs3_pc_portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6084299c"]])

export default __exports__